export default function BulletRenderer({ section }){

    return(

        <ul>

            {(section.value || []).map((item,index)=>(

                <li key={index}>{item}</li>

            ))}

        </ul>

    );

}